import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { clientRoute } from '../route';

export const verifyIdentityRoute = createRoute({
	path: '/verify-identity',
	getParentRoute: () => clientRoute,
	validateSearch: z.object({
		operationUuid: z.string().optional(),
	}),
	component: lazyRouteComponent(
		() => import('./VerifyIdentityPage'),
		'VerifyIdentityPage',
	),
});
